export default __webpack_public_path__ + "media/images/react_icons/casatb/casatb_pointer_map-8025828fe31e80f1b22a53f0d1943f14.svg";